import {ASSETS_HOST} from '../../consts';
import type {Collection, CollectionsData, MainCollection} from '@Corrl/vocabeo-shared-types';
import type {WordId} from '$lib/classes/data/_primitives';

export class CollectionManager {

    private _value: CollectionsData | null = null;

    get collections(): ReadonlyArray<MainCollection> {
        return this._value?.collections ?? []
    }

    private _wordIdToCollectionIds: Record<WordId, Collection['id'][]> = {}

    constructor() {}

    async init() {
        try {
            const response = await fetch(`${ASSETS_HOST}/collections.json`)
            if (response.ok) {
                const collectionsData = await response.json() as CollectionsData
                this._value = collectionsData
                this._wordIdToCollectionIds = collectionsData.wordToCollectionLinks.reduce((acc, wordToCollectionLink) => {
                    const collectionIds = acc[wordToCollectionLink.wordId]
                    if (collectionIds && !collectionIds.includes(wordToCollectionLink.collectionId)) {
                        collectionIds.push(wordToCollectionLink.collectionId)
                    } else {
                        acc[wordToCollectionLink.wordId] = [wordToCollectionLink.collectionId]
                    }
                    return acc
                }, {} as Record<WordId, Collection['id'][]>)
            } else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error('reponse.status ' + response.status)
            }
        } catch (error) {
            throw new Error('ERROR CollectionManager.init', {cause: error})
        }
    }

    getCollectionIds(wordId: WordId): Collection['id'][] {
        return this._wordIdToCollectionIds[wordId] || [];
    }
}